import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ExternalLink, BadgeCheck, Flame } from "lucide-react";
import { FaAmazon } from "react-icons/fa";
import { LINKS } from "@/constants/links";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const AMAZON_TAG = "barberlatin0a-21";
const amazonSearch = (q) => `https://www.amazon.it/s?k=${encodeURIComponent(q)}&tag=${AMAZON_TAG}`;
const AMAZON_DEALS = `https://www.amazon.it/deals?tag=${AMAZON_TAG}`;

export const PRODUCTS = [
  {
    name: "Cere e Pomate",
    q: "cera e pomata capelli uomo",
    img: "https://images.pexels.com/photos/5192478/pexels-photo-5192478.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Tagliacapelli Pro",
    q: "tagliacapelli professionale",
    img: "https://images.pexels.com/photos/20785314/pexels-photo-20785314.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Kit Cura Barba",
    q: "kit cura barba uomo",
    img: "https://images.pexels.com/photos/14649387/pexels-photo-14649387.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Forbici & Strumenti",
    q: "forbici barbiere professionali",
    img: "https://images.pexels.com/photos/13809242/pexels-photo-13809242.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Mantelline da Salone",
    q: "mantellina barbiere professionale",
    img: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  },
  {
    name: "Carta Collo & Igiene",
    q: "carta collo barbiere rotolo",
    img: "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  },
  {
    name: "Talco da Barbiere",
    q: "talco barbiere mentolato",
    img: "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  },
  {
    name: "Grooming Premium",
    q: "prodotti grooming uomo",
    img: "https://images.unsplash.com/photo-1785144983542-9963738baf60?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxtZW5zJTIwZ3Jvb21pbmclMjBwcm9kdWN0c3xlbnwwfHx8fDE3ODY5MzA5NjR8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Gel per Capelli",
    q: "gel capelli uomo",
    img: "https://images.pexels.com/photos/7440139/pexels-photo-7440139.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Shampoo Uomo",
    q: "shampoo uomo capelli",
    img: "https://images.pexels.com/photos/7440141/pexels-photo-7440141.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Dopobarba",
    q: "dopobarba uomo",
    img: "https://images.pexels.com/photos/8789597/pexels-photo-8789597.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Rasoi & Lame",
    q: "rasoio a mano libera e lamette barbiere",
    img: "https://images.pexels.com/photos/13386932/pexels-photo-13386932.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export default function ProductsPage() {
  const [overrides, setOverrides] = useState({});
  const [links, setLinks] = useState({});

  useEffect(() => {
    fetch(`${BACKEND}/api/product-images`)
      .then((r) => r.json())
      .then((d) => setOverrides(d || {}))
      .catch(() => {});
    fetch(`${BACKEND}/api/product-links`)
      .then((r) => r.json())
      .then((d) => setLinks(d || {}))
      .catch(() => {});
  }, []);
  return (
    <div data-testid="page-categoria" className="flex flex-col gap-6">
      <header className="flex flex-col gap-2">
        <span className="inline-flex w-fit items-center gap-2 rounded-full border border-amber-400/30 bg-amber-400/10 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-amber-300">
          <BadgeCheck size={12} /> Scelti dal barbiere
        </span>
        <h2 className="font-display text-3xl font-bold text-white">I miei prodotti</h2>
        <p className="text-sm text-zinc-400">
          Solo quelli che uso davvero in salone. Tocca un prodotto e acquistalo su Amazon.
        </p>
      </header>

      <div className="grid grid-cols-2 gap-4" data-testid="product-grid">
        <a
          data-testid="deals-banner"
          href={AMAZON_DEALS}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative col-span-2 overflow-hidden rounded-2xl border border-amber-400/30 transition-[transform,border-color] duration-200 hover:border-amber-400/60 active:scale-[0.98]"
        >
          <img
            src="https://images.pexels.com/photos/19643875/pexels-photo-19643875.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Tutte le offerte di Amazon in tendenza"
            loading="lazy"
            className="h-36 w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-zinc-950/55" />
          <div className="absolute inset-x-0 bottom-0 h-24 bg-zinc-950 [mask-image:linear-gradient(to_top,black,transparent)]" />
          <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-4">
            <div>
              <span className="mb-1.5 inline-flex items-center gap-1.5 rounded-full bg-amber-400 px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-widest text-zinc-950">
                <Flame size={11} /> In tendenza
              </span>
              <span className="block text-base font-extrabold text-white">
                Tutte le Offerte di Amazon
              </span>
              <span className="block text-xs text-zinc-300">Sconti e offerte del momento</span>
            </div>
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-amber-400 text-zinc-950">
              <ExternalLink size={16} />
            </span>
          </div>
        </a>
        {PRODUCTS.map((p, i) => {
          const src = overrides[p.name] ? `${BACKEND}/api/media/file/${overrides[p.name]}` : p.img;
          return (
          <motion.a
            key={p.name}
            data-testid={`product-${i}`}
            href={links[p.name] || amazonSearch(p.q)}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-30px" }}
            transition={{ duration: 0.45, delay: (i % 2) * 0.08, ease: "easeOut" }}
            className="group overflow-hidden rounded-2xl border border-white/10 bg-zinc-900 transition-[transform,border-color] duration-200 hover:border-amber-400/40 active:scale-[0.97]"
          >
            <div className="relative aspect-square overflow-hidden">
              <img
                src={src}
                alt={p.name}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <span className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-zinc-950/70 text-amber-400 backdrop-blur">
                <ExternalLink size={13} />
              </span>
            </div>
            <div className="flex items-center justify-between px-3 py-2.5">
              <span className="text-xs font-bold text-white">{p.name}</span>
              <FaAmazon size={14} className="text-amber-400" />
            </div>
          </motion.a>
          );
        })}
      </div>

      <a
        data-testid="btn-amazon-all"
        href={LINKS.amazon}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-3 rounded-2xl bg-amber-400 px-5 py-4 text-base font-extrabold text-zinc-950 shadow-[0_0_24px_rgba(251,191,36,0.25)] transition-[background-color,transform] duration-200 hover:bg-amber-300 active:scale-[0.97]"
      >
        <FaAmazon size={20} /> Vedi tutto su Amazon
      </a>

      <p className="text-xs leading-relaxed text-zinc-500" data-testid="affiliate-disclosure">
        In qualità di Affiliato Amazon, potrei ricevere una commissione dagli acquisti idonei
        effettuati tramite questo link, senza costi aggiuntivi per te.
      </p>
    </div>
  );
}
